import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        <a href="mailto:info@crunchdecor.com">info@crunchdecor.com</a>
      </div>
    </footer>
  );
}

export default Footer;
